

<template>
  <div class="button" @click="execute">
    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260702/600b3cc02fd8b632c06156516f9843c3.png" alt="">
    <p>
      <span>观看影片</span>
      <svg t="1765793230924" class="button-play" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1952" width="200" height="200"><path d="M540.032 70.976c-245.952 0-446.016 200.064-446.016 446.016s200.064 446.016 446.016 446.016 446.016-200.064 446.016-446.016-200.064-446.016-446.016-446.016z m0 828.032c-210.624 0-382.016-171.392-382.016-382.016s171.392-382.016 382.016-382.016 382.016 171.392 382.016 382.016-171.392 382.016-382.016 382.016z" p-id="1953" fill="#ffffff"></path><path d="M417.152 643.84c0 35.2 24.96 49.6 55.424 32l219.584-126.784c30.528-17.6 30.528-46.4 0-64L472.576 358.208c-30.528-17.6-55.424-3.2-55.424 32v253.632z" p-id="1954" fill="#ffffff"></path></svg>
    </p>
  </div>
</template>

<script>
export default {
  name: 'endo-button',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    execute(){
      this.$emit('onclick', this.url);
    },
  }
}
</script>

<style scoped>
.button {
  cursor: pointer;
  width: 120px;
  opacity: 0.8;
  transition: all .3s linear 0s;
  position: relative;
}

.button img {
  width: 100%;
  display: block;
}

.button:hover {
  opacity: 1;
}

.button p {
  font-size: 13px;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #ffffff;
  text-align: center;
}

.button .button-play {
  width: 17px;
  height: 17px;
  margin-left: 2px;
}

p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 20px;
  color: #7d7d7d;
  margin: 0;
  padding: 0;
}

</style>